export type { ToolSymbolMap } from '@cotera/api';
import type { CompositeUddWriteKey, ToolSymbolMap } from '@cotera/api';

export const BUILTIN_FUNCTION_IDENTIFIERS = ['now', 'rand', 'fail'];
export type BuiltinFunctionIdentifier =
  (typeof BUILTIN_FUNCTION_IDENTIFIERS)[number];

export type StackFrameDef =
  | {
      readonly t: 'program';
      readonly eraql: string;
      readonly toolSymbolMap: ToolSymbolMap;
      readonly uddWriteKey: CompositeUddWriteKey | null; // eg repl programs have no need to write udd
    }
  | { readonly t: 'builtin'; readonly name: BuiltinFunctionIdentifier }
  | {
      readonly t: 'tool';
      readonly id: string;
      readonly forceApproveAllocations?: boolean;
    }
  | {
      readonly t: 'tool-call';
      readonly id: string;
    }
  | {
      readonly t: 'sleep';
    }
  | {
      readonly t: 'llm-call';
    }
  | {
      readonly t: 'agent';
      readonly toolSymbolMap: ToolSymbolMap;
      readonly uddWriteKey: CompositeUddWriteKey | null;
    };
